class DataStore {
    constructor() {
        /* scrolling ++++++++++++++++++++++++++++++++++++++++++*/
        this.docScroll = '';
        this.win = $(window);
        this.body = $('body');
        this.html = $('html');
        /* window ++++++++++++++++++++++++++++++++++++++++++*/

        this.docWidth = $(document).width();
        this.docHeight = $(document).height();
        this.winHeight = $(window).height();

        /* non editable ++++++++++++++++++++++++++++++++++++++++++*/
        this.endOfResize = false;

        /* browser ++++++++++++++++++++++++++++++++++++++++++*/

        this.isIe = false;
        this.isFirefox = false;
        this.isSafari = false;
        this.isNoIe = false;
        this.touch = false;
        this.touchBreakPoint = 1199.98;
        this.isHoverableDevice = !this.touch;

        /* ids ++++++++++++++++++++++++++++++++++++++++++*/
        this.globalIds = JSON.parse(window.wp_urls.globalIds);

        /* fancybox ++++++++++++++++++++++++++++++++++++++++++*/
        this.fancyBoxOnceOpened = false;

        /* lightbox ++++++++++++++++++++++++++++++++++++++++++*/
        this.lightbox = '';

        /* smoothscrolling ++++++++++++++++++++++++++++++++++++++++++*/
        this.scrollEventListener = 'wheel';
        this.smoothDisabled = false;

        /* masonry ++++++++++++++++++++++++++++++++++++++++++*/
        this.grid = '';
        this.$container = $('.masonry');

        /* lazyload ++++++++++++++++++++++++++++++++++++++++++*/
        this.lazyLoadInstance = '';

        /* Map ++++++++++++++++++++++++++++++++++++++++++*/
        this.mapMarkers = [];
        this.map = '';

        this.theContent = $('#theContent');

        /* Steps ++++++++++++++++++++++++++++++++++++++++++*/
        this.stepsScrollerLength = $('.stepsScrollContainer').length;
        if (this.stepsScrollerLength) {
            this.stepsDateScrollerOffsetTop = $('.stepsScrollContainer').offset().top;
            this.stepsDateScrollerHeiht = $('.stepsScrollContainer').height();
        }
    }
}

export default (new DataStore());
